


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../Components/Header';
import Rightcontainer from '../Components/Rightcontainer';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { BsArrowRight } from 'react-icons/bs';
import { FiEdit, FiUploadCloud } from 'react-icons/fi';
import { FaQrcode, FaShieldAlt } from 'react-icons/fa';
import { RiWallet3Fill } from 'react-icons/ri';

// Imported decoupled presentation layer
// import "./Addcase.css";

const Addcase = ({ walletUpdate }) => {
  const history = useHistory();
  const access_token = localStorage.getItem('token');

  const [amount, setAmount] = useState('');
  const [step, setStep] = useState(1);
  const [userAllData, setUserAllData] = useState(null);
  const [upiList, setUpiList] = useState([]);
  const [selectedUpi, setSelectedUpi] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [utr, setUtr] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [settinData, setSettinData] = useState(null);

  useEffect(() => {
    const setting = localStorage.getItem('sitSetting');
    if (setting) setSettinData(JSON.parse(setting));
  }, []);

  useEffect(() => {
    axios
      .get('https://api.kakaking.in/me', { headers: { Authorization: `Bearer ${access_token}` } })
      .then(res => setUserAllData(res.data))
      .catch(e => {
        if (e.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.reload();
        }
      });
  }, [access_token]);

  useEffect(() => {
    const fetchUpi = async () => {
      try {
        const { data } = await axios.get('https://api.kakaking.in/upi/getUpiAll', {
          headers: { Authorization: `Bearer ${access_token}` },
        });
        if (data.status) setUpiList(Array.isArray(data.data) ? data.data : [data.data]);
      } catch {
        console.error('Failed to fetch UPI list');
      }
    };
    fetchUpi();
  }, [access_token]);

  const handleNext = () => {
    const amt = Number(amount);
    if (!amt || isNaN(amt)) {
      Swal.fire({ title: 'Invalid Amount', text: 'Please enter a valid number', icon: 'warning' });
      return;
    }
    if (amt < (settinData?.depositlimitMin || 0)) {
      Swal.fire({ title: 'Minimum Limit', text: `Minimum deposit is ₹${settinData?.depositlimitMin}`, icon: 'warning' });
      return;
    }
    setStep(2);
  };

  const handleFileChange = e => setScreenshot(e.target.files[0]);

  const handleSubmitPayment = async () => {
    if (!utr) {
      Swal.fire({ title: 'UTR Required', text: 'Please enter the 12-digit UTR number', icon: 'warning' });
      return;
    }
    setIsLoading(true);
    try {
      const formData = new FormData();
      if (screenshot) formData.append('Transaction_Screenshot', screenshot);
      formData.append('amount', amount);
      formData.append('referenceId', utr);

      const { data } = await axios.post(
        'https://api.kakaking.in/manual/deposit/txn',
        formData,
        { headers: { Authorization: `Bearer ${access_token}` } }
      );

      setIsLoading(false);
      Swal.fire({ title: 'Submitted', text: data.message, icon: 'success' });
      if (walletUpdate) walletUpdate();
      setShowModal(false);
      setStep(1);
      setAmount('');
      setUtr('');
    } catch {
      setIsLoading(false);
      Swal.fire({ title: 'Error', text: 'Submission failed', icon: 'error' });
    }
  };

  const handleIMBGateway = async () => {
    if (!amount || amount <= 0) {
      Swal.fire({ title: "Enter valid amount", icon: "warning" });
      return;
    }
    try {
      const res = await axios.get(
        `https://api.kakaking.in/imb-request?amount=${amount}`,
        { headers: { Authorization: `Bearer ${access_token}` } }
      );
      const data = res.data;
      if (data?.status === true && data?.payment_url) {
        Swal.fire({ title: "Redirecting...", icon: "info", timer: 1500, showConfirmButton: false });
        setTimeout(() => { window.location.href = data.payment_url; }, 1200);
        return;
      }
      Swal.fire({ title: data?.msg || "Failed to create order", icon: "error" });
    } catch (err) {
      Swal.fire({ title: "Gateway connection failed", icon: "error" });
    }
  };
  const handleZapUPIGateway = async () => {
    if (!amount || Number(amount) <= 0) {
      Swal.fire({
        title: "Enter valid amount",
        icon: "warning",
      });
      return;
    }

    const newTab = window.open("", "_blank");

    try {
      const res = await axios.get(
        `https://api.kakaking.in/zapupi-request?amount=${amount}`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      const data = res.data;

      if (data?.status && data?.payment_url) {
        newTab.location.href = data.payment_url;

        Swal.fire({
          title: "Redirecting...",
          text: "Please complete your payment.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        return;
      }

      newTab.close();

      Swal.fire({
        title: data?.msg || "Unable to create order",
        icon: "error",
      });

    } catch (err) {

      if (newTab) {
        newTab.close();
      }

      Swal.fire({
        title: "Gateway Error",
        text: err?.response?.data?.msg || "Something went wrong.",
        icon: "error",
      });
    }
  };

  const filteredUpiList = upiList.filter(upi => Number(amount) >= upi.limitFrom && Number(amount) <= upi.limitTo);
  const gatewayUpi = upiList.find(upi => Number(amount) >= upi.gatewayMin && Number(amount) <= upi.gatewayMax);

  const quickAmounts = [100, 250, 500, 2000].filter(v => v >= (settinData?.depositlimitMin || 0));

  return (
    <>
      <Header user={userAllData} />
      <div className="addcase-premium-viewport mt-5 pt-5">
        <div className="addcase-bg-orb orb-primary"></div>
        <div className="addcase-bg-orb orb-secondary"></div>

        <div className="container-fluid px-3 pt-3">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9 main-addcase-column">

              <div className="addcase-shield-announcement">
                <div className="shield-icon-pod-3d">
                  <FaShieldAlt />
                </div>
                <p>{settinData?.rkRummyMsg || 'Secure Payment Gateway: Enter amount and proceed to deposit.'}</p>
              </div>

              {/* STEP 1: AMOUNT MANAGEMENT MODULE */}
              {step === 1 && (
                <div className="screenshot-layout-card-3d animated-fade-in-up">
                  <h3 className="layout-section-main-title">
                    Choose Amount To Add <span className="money-bag-emoji">💰</span>
                  </h3>

                  <div className="screenshot-input-engraved-well">
                    <span className="input-well-context-label">ENTER AMOUNT</span>
                    <div className="input-well-flex-field">
                      <div className="tactile-3d-coin-addon">
                        <span>₹</span>
                      </div>
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="0"
                        className="screenshot-core-input-element"
                      />
                    </div>
                  </div>

                  <div className="limit-micro-text-row">
                    <span>Min: ₹{settinData?.depositlimitMin || 0}</span>
                    <span>Max: ₹{settinData?.depositlimitMax || 'N/A'}</span>
                  </div>

                  <div className="screenshot-quick-chip-matrix">
                    {quickAmounts.map((val) => (
                      <button
                        key={val}
                        type="button"
                        onClick={() => setAmount(val.toString())}
                        className={`screenshot-tactile-chip-btn ${amount == val ? 'chip-btn-state-active' : ''}`}
                      >
                        ₹{val}
                      </button>
                    ))}
                  </div>

                  <button onClick={handleNext} type="button" className="screenshot-primary-3d-action-btn gold-gradient-trigger">
                    <span>NEXT</span> <BsArrowRight className="btn-arrow-icon-right" />
                  </button>
                </div>
              )}

              {/* STEP 2: METHOD ROUTING SCREEN */}
              {step === 2 && (
                <div className="screenshot-layout-card-3d animated-fade-in-up">
                  <div className="screenshot-receipt-pod-header">
                    <div className="receipt-pod-left-meta">
                      <div className="mini-wallet-pod-circle">
                        <span>₹</span>
                      </div>
                      <div className="receipt-pod-txt">
                        <span className="receipt-sub-label">AMOUNT TO BE ADDED</span>
                        <h3 className="receipt-main-numeric">₹{amount}</h3>
                      </div>
                    </div>
                    <button type="button" onClick={() => setStep(1)} className="screenshot-tactile-edit-btn">
                      <FiEdit className="me-1" /> Edit
                    </button>
                  </div>

                  <h5 className="screenshot-routing-section-label">PAY THROUGH QR CODE</h5>

                  <div className="screenshot-methods-distribution-stack">
                    {settinData?.autoSwitch && gatewayUpi && (
                      <button type="button" onClick={handleIMBGateway} className="screenshot-primary-3d-action-btn gold-gradient-trigger routing-style-btn mb-3">
                        <div className="routing-btn-icon-capsule">
                          <RiWallet3Fill />
                        </div>
                        <span>Pay QR Code (UPI)</span>
                        <span className="routing-arrow-indicator">↗</span>
                      </button>
                    )}

                    {settinData?.isManualDeposit && filteredUpiList.map(upi => (
                      <div
                        key={upi._id}
                        onClick={() => { setSelectedUpi(upi); setStep(3); }}
                        className="screenshot-manual-method-row-plate"
                      >
                        <div className="manual-method-left-group">
                          <div className="manual-method-avatar-icon">
                            <FaQrcode />
                          </div>
                          <div className="manual-method-typography">
                            <h6>Manual UPI Deposit</h6>
                            <p>Verify via UTR Upload Matrix</p>
                          </div>
                        </div>
                        <span className="manual-method-arrow">→</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* STEP 3: OPTIMIZED QR CODE TERMINAL INTERFACE (NO-SCROLL PRESET) */}
              {step === 3 && selectedUpi && (
                <div className="screenshot-layout-card-3d animated-fade-in-up text-center qr-no-scroll-override">
                  <h4 className="qr-terminal-title-text">Scan Terminal QR to Pay</h4>

                  <div className="qr-terminal-3d-scan-frame">
                    <div className="qr-terminal-animated-laser"></div>
                    <img
                      src={`https://api.kakaking.in${selectedUpi.qrImage}`}
                      alt="Deposit QR"
                      className="qr-terminal-core-image-element"
                    />
                  </div>

                  <div className="qr-terminal-id-copy-well-plate">
                    <small className="copy-well-label">UPI ID Address Pointer</small>
                    <div className="copy-well-flex-row">
                      <span className="copy-well-address-string">{selectedUpi.upiId}</span>
                      <button
                        type="button"
                        className="copy-well-tactile-action-btn"
                        onClick={() => {
                          navigator.clipboard.writeText(selectedUpi.upiId);
                          Swal.fire({ title: 'Copied!', icon: 'success', timer: 1000, showConfirmButton: false, background: '#fff', iconColor: '#e5a919' });
                        }}
                      >
                        Copy
                      </button>
                    </div>
                  </div>

                  <div className="qr-terminal-action-cluster">
                    <button
                      type="button"
                      className="screenshot-primary-3d-action-btn green-gradient-trigger condensed-action-btn"
                      onClick={() => setShowModal(true)}
                    >
                      Submit UTR Number
                    </button>
                    <button type="button" onClick={() => setStep(2)} className="qr-terminal-back-btn-link">Back to Methods</button>
                  </div>
                </div>
              )}

            </div>

            <div className="col-lg-4 d-none d-lg-block">
              <Rightcontainer />
            </div>
          </div>
        </div>
      </div>

      {/* UTR MANUAL OVERRIDE VERIFICATION PROOF MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered dialogClassName="premium-utr-modal-wrapper">
        <div className="utr-modal-lux-content-frame">
          <Modal.Header closeButton className="utr-modal-header-container">
            <Modal.Title className="utr-modal-main-title">Verification Proof</Modal.Title>
          </Modal.Header>
          <Modal.Body className="utr-modal-body-container">

            <div className="utr-field-input-group">
              <label>12-Digit Reference/UTR Number</label>
              <input
                type="number"
                placeholder="Ex: 301234567890"
                value={utr}
                onChange={e => setUtr(e.target.value)}
                className="utr-field-core-element"
              />
            </div>

            <div className="utr-upload-dropzone-group">
              <label className="utr-dropzone-label-trigger-surface">
                <div className="utr-dropzone-inner-blueprint">
                  <FiUploadCloud className="utr-upload-icon-cloud" />
                  <p>{screenshot ? screenshot.name : 'Upload Screenshot (Optional)'}</p>
                </div>
                <input type="file" hidden onChange={handleFileChange} accept="image/*" />
              </label>
            </div>

            <button
              type="button"
              disabled={isLoading}
              onClick={handleSubmitPayment}
              className={`screenshot-primary-3d-action-btn gold-gradient-trigger modal-submit-override ${isLoading ? 'submit-state-loading' : ''}`}
            >
              {isLoading ? <Spinner size="sm" /> : <span>Confirm Transaction</span>}
            </button>

          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default Addcase;